import SliderObjects from './slider';
import { openAuthorizationModal } from "./authorization";

function modalObjects() {
	const Modal = $('.object-modal');
	if (!Modal.length) {
		return false;
	}

	let setPolygons = (polygons) => {
		Modal[0].map.geoObjects.removeAll();
		if (polygons && polygons.length) {
            let minX = Number.MAX_VALUE, maxX = 0, minY = Number.MAX_VALUE, maxY = 0;
			polygons.forEach((p) => {
			    if (Array.isArray(p.coords)) {
			        p.coords.forEach(point => {
			            minX = Math.min(minX, point[0]);
			            maxX = Math.max(maxX, point[0]);
                        minY = Math.min(minY, point[1]);
                        maxY = Math.max(maxY, point[1]);
                    });
                }
				let myPolygon = new ymaps.Polygon(
					[p.coords, []],
					{},
					{
						fillColor: 'rgba(84,250,255,0.31)',
						strokeColor: '#4b95da',
						strokeWidth: 3,
					}
				);

				Modal[0].map.geoObjects.add(myPolygon);
			});
            Modal[0].map.setBounds([[minX, minY], [maxX, maxY]]);
		}
	};

	let initMap = (poligons) => {
		Modal[0].map = new ymaps.Map("js-object-map", {
			center: [53.720333, 91.438036],
			zoom: 12,
		});

		setPolygons(poligons);
	};

	let getObjectIndex = (objectId) => {
	    if (Array.isArray(objectsIndexes)) {
            return objectsIndexes.map(el => +el).indexOf(+objectId)
        } else {
	        return -1;
        }
    };

	let changeSelectedObject = (offset) => {
        let curIndex = getObjectIndex(Modal[0].selectedObjectId);
        let nextObjectId = objectsIndexes[curIndex + offset];
        if (nextObjectId) {
            displayObjectInfo(nextObjectId);
            ymaps.ready(() => {
				Modal[0].map.container.fitToViewport();

			});
        }
    };

	let displayObjectInfo = (objectId) => {
        Modal[0].selectedObjectId = objectId;
        let object = window.objectsData[objectId];
        if (!object) {
            return false;
        }
        Modal.find('.js-object-name').html(object.name);
        Modal.find('.js-object-description').html(object.large_description);
        Modal.find('.js-description-tab').attr('disabled', !object.large_description);
        let $plan = Modal.find('.js-object-plan');
        $plan.attr('href', object.plan);
        $plan.find('img').attr('src', object.plan_thumbnail);
        Modal.find('.js-plan-tab').attr('disabled', !object.plan);
        SliderObjects.destroy();
        let $slider = Modal.find('.js-object-slider');
        $slider.empty();
        let html = '';
        if (Array.isArray(object.images)) {
            object.images.forEach(img => {
                html += `
					<div class="slide">
						<a class="slide-body" data-fancybox="gallery" href="${img.url}"><img src="${img.thumbnail}" alt=""></a>
					</div>
				`;
            });
        }
        $slider.html(html);
        if (Modal.css('display') !== 'none') {
			SliderObjects.init();
		}
        Modal.find('.js-gallery-tab').attr('disabled', !object.images || !object.images.length);
        let map = [];
        try {
            map = JSON.parse(object.map) || [];
        } catch (e) {
            map = [];
        }
        Modal.find('.js-map-tab').attr('disabled', !map || !map.length);
        if (!Modal[0].map) {
            ymaps.ready(() => initMap(map));
        } else {
            setPolygons(map);
        }

        let curIndex = getObjectIndex(objectId);
        Modal.find('.js-current-position').text(`${curIndex + 1} из ${objectsIndexes.length}`);
        Modal.find('.js-prev-object').attr('disabled', curIndex === 0);
        Modal.find('.js-next-object').attr('disabled', curIndex + 1 >= objectsIndexes.length);

        UpdateModalButtons();

        if (!Modal[0].shareButtons) {
			let $share = $("#share");
			Modal[0].shareButtons = Ya.share2($share[0], {
        		theme: {
        			bare: true,
					copy: 'hidden',
					services: 'vkontakte,odnoklassniki,facebook',
				}
			})
		}

        Modal[0].shareButtons.updateContent({
			title: object.name,
			image: window.siteUrl + object.preview,
			url: window.siteUrl + window.pollLink + object.id,
		});


        Modal.find('.super-tabs__radio:not(:disabled)').eq(0).prop('checked', true);

        let newUrl = window.siteUrl + window.pollLink + objectId;
        if (newUrl !== location.href) {
			window.history.pushState({}, '', newUrl);
		}

        return true;
    };

	let openModal = (objectId) => {
		if (displayObjectInfo(objectId) && !isModalOpen()) {
			Modal.fadeIn(300, () => {
				SliderObjects.init();
				if (Modal[0].map) {
					Modal[0].map.container.fitToViewport();
				}
			});
		}
	};

	let closeModal = (changeHistory = true) => {
		if (isModalOpen()) {
			Modal.fadeOut(300, () => {
				SliderObjects.destroy();
			});
			if (changeHistory) {
				window.history.pushState({}, '', window.pollLink);
			}
		}
	};

	let isModalOpen = () => {
		return Modal.css('display') !== 'none';
	};

	$('.js-open-info').on('click', function() {
		let objectId = $(this).closest('.js-object').data('object-id');
		openModal(objectId);
	});
	$('.js-close-info').on('click', () => {
		closeModal();
	});

    $('.js-prev-object').on('click', function() {
        changeSelectedObject(-1);
    });
	$('.js-next-object').on('click', function() {
	   changeSelectedObject(1);
    });
	Modal.find('.js-modal-vote').on('click', function() {
		let callback = () => $(this).removeClass("loading").attr('disabled', false);
	    let curObject = Modal[0].selectedObjectId;
		if (!window.isAuthorized) {
			window.authCallback = () => {
				$(this).addClass("loading").attr('disabled', true);
				vote(curObject, callback);
			};
			openAuthorizationModal();
		} else {
			$(this).addClass("loading").attr('disabled', true);
			vote(curObject, callback);
		}
    });

	if (window.objectId) {
		openModal(window.objectId);
	}

	$(window).on('popstate', function(e) {
		let urlParts = window.location.pathname.split('/').filter(str => str.length > 0);
		if (urlParts.length === 0) {
			closeModal(false);
		} else {
			let objectId = +urlParts.pop();
			if (objectId != Modal[0].selectedObjectId) {
				openModal(objectId);
			}
		}
	});
}

function UpdateModalButtons() {
    let Modal = $('.object-modal');
    let curObject = Modal[0].selectedObjectId;
    if (!Modal.length || !curObject) {
        return;
    }
    if (window.votedObjects.map(el => +el).indexOf(+curObject) !== -1) {
        $('.js-modal-vote-buttons').addClass('object-voited--completion');
    } else {
        $('.js-modal-vote-buttons').removeClass('object-voited--completion');
    }
}

function init() {
	modalObjects();

	$('.js-card-vote-button').on('click', function() {
		let objectId = $(this).closest('.js-object').data('object-id');
		let callback = () => $(this).removeClass("loading").attr('disabled', false);
		if (!window.isAuthorized) {
			window.authCallback = () => {
				$(this).addClass("loading").attr('disabled', true);
				vote(objectId, callback);
			};
			openAuthorizationModal();
		} else {
			$(this).addClass("loading").attr('disabled', true);
			vote(objectId, callback);
		}
	});
}

export function getResults() {
	let pollId = $('#poll-id').val();
	$.post('/handlers/vote', {action: 'getResults', poll: pollId}, function(r) {
		if (r.status) {
			displayResults(r.results, r.votedObjects.map(el => +el));
		}
	}, 'json');
}

function displayResults(objects, votedObjects, voted) {
	let $list = $('.voting__list');
	let $objects = $('#objects');
	$objects.find('.sn-object--voted').removeClass('sn-object--voted');
	for (let id in objects) {
		let obj = objects[id];
		let $row = $list.find('.js-result-item[data-id="' + obj.id + '"]');
		if (votedObjects.indexOf(+obj.id) !== -1) {
			$row.addClass('voting__item--selected');
			$objects.find('.js-object[data-object-id="' + obj.id + '"]').addClass('sn-object--voted');
		}
		$row.find('.js-votes').text(obj.votes);
		$row.find('.js-percentage').text(obj.percentage);
		$row.find('.js-progress').css({width: obj.percentage + '%'});
	}

	$('.voting--hide-results').removeClass('voting--hide-results');
	if (typeof voted !== 'undefined') {
		$('.js-voted').text(voted);
	}
}

export function hideResults() {
	let $list = $('.voting__list');
	let $objects = $('#objects');
	$objects.find('.sn-object--voted').removeClass('sn-object--voted');
	$list.find('.js-result-item').each(function() {
		let $row = $(this);
		$row.removeClass('voting__item--selected');
		$row.find('.js-votes').text(0);
		$row.find('.js-percentage').text(0);
		$row.find('.js-progress').css({width: 0});
	});

	$('.voting').addClass('voting--hide-results');
}

function vote(objectId, callback) {
	let pollId = $('#poll-id').val();
	$.post('/handlers/vote', {action: 'vote', data: JSON.stringify({poll: pollId, objects: [objectId]})}, function(r) {
		if (r.status) {
		    window.votedObjects = r.votedObjects;
			displayResults(r.results, r.votedObjects, r.voted);
			UpdateModalButtons();
			if (r.ignored) {
				window.toastr.error('Вы уже голосовали за этот объект');
			} else {
				window.toastr.success('Ваш голос учтен');
			}
		} else {
			window.toastr.error('Произошла ошибка, пожалуйста, попробуйте позже');
		}
		if (callback) {
		    callback(r);
        }
	}, 'json');
}

export default {
	init,
}
